import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { AssetMaintenance, AssetMaintenanceCreate, AssetMaintenanceFilter } from '../data/assetMaintenance';

export function createAssetMaintenanceService(client: AxiosInstance) {
  return createCrudService<AssetMaintenance, AssetMaintenanceCreate, AssetMaintenanceFilter>(
    client,
    '/asset-management/AssetMaintenance',
    'id',
  );
}

export type AssetMaintenanceService = CrudService<AssetMaintenance, AssetMaintenanceCreate, AssetMaintenanceFilter>;
